import styled from "styled-components";

const bp = { sm: "560px" };

const c = {
  white: "#ffffff",
  ink: "rgba(12,12,12,0.88)",
  inkSoft: "rgba(12,12,12,0.62)",
  line: "rgba(0,0,0,0.10)",

  gold: "#c9a227",
  pink: "#ff77b4",
  black: "#1e1e1e",
};

export const Page = styled.section`
  min-height: 100vh;
  background: ${c.white};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 70px 18px;
`;

export const Inner = styled.div`
  width: 100%;
  max-width: 760px;
  text-align: center;
`;

export const Kicker = styled.div`
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.55);
  margin-bottom: 10px;
`;

export const Title = styled.h1`
  margin: 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 54px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: ${c.ink};

  @media (max-width: ${bp.sm}) {
    font-size: 40px;
  }
`;

export const Text = styled.p`
  margin: 14px auto 0;
  max-width: 60ch;
  font-size: 16px;
  line-height: 1.75;
  color: ${c.inkSoft};
`;

export const Divider = styled.div`
  margin: 26px auto 22px;
  width: min(560px, 92%);
  height: 1px;
  background: ${c.line};
  position: relative;

  &::before {
    content: "◆";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -55%);
    font-size: 13px;
    color: rgba(201, 162, 39, 0.95);
    background: ${c.white};
    padding: 0 10px;
  }
`;

export const StatusLine = styled.div`
  margin: 10px auto 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 22px;
  letter-spacing: 0.02em;
  color: rgba(150, 25, 25, 0.92);
`;

const btnBase = `
  border-radius: 999px;
  padding: 12px 18px;
  font-size: 12px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.15s ease, border-color 0.15s ease, background 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;

export const PrimaryBtn = styled.button`
  ${btnBase}
  background: ${c.black};
  color: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(201, 162, 39, 0.35);

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(255, 119, 180, 0.55);
  }
  &:active {
    transform: translateY(0px);
  }
`;

export const GhostBtn = styled.button`
  ${btnBase}
  background: transparent;
  color: rgba(0, 0, 0, 0.78);
  border: 1px solid rgba(0, 0, 0, 0.16);

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(201, 162, 39, 0.55);
    background: rgba(201, 162, 39, 0.06);
  }
  &:active {
    transform: translateY(0px);
  }
`;
